import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/home/HomePage"], resolve),
          meta: {
            title: "创念三维"
          }
        },
        {
          path: "/product",
          name: "product",
          component: resolve => require(["@/view/product/product"], resolve)
        },
        {
          path: "/product_car1",
          name: "product_car1",
          component: resolve => require(["@/view/product/car1"], resolve)
        },
        {
          path: "/product_car2",
          name: "product_car2",
          component: resolve => require(["@/view/product/car2"], resolve)
        },
        {
          path: "/product_boat1",
          name: "product_boat1",
          component: resolve => require(["@/view/product/boat1"], resolve)
        },
        {
          path: "/product_plane4",
          name: "product_plane4",
          component: resolve => require(["@/view/product/plane4"], resolve)
        },
        {
          path: "/product_plane6",
          name: "product_plane6",
          component: resolve => require(["@/view/product/plane6"], resolve)
        },
        {
          path: "/product_planeSt",
          name: "product_planeSt",
          component: resolve => require(["@/view/product/planeSt"], resolve)
        },
        {
          path: "/product_planekuafu600",
          name: "product_planekuafu600",
          component: resolve =>
            require(["@/view/product/planekuafu600"], resolve)
        },
        {
          path: "/product_planefalcon",
          name: "product_planefalcon",
          component: resolve => require(["@/view/product/planeFalcon"], resolve)
        },
        {
          path: "/product_RS100i",
          name: "product_RS100i",
          component: resolve => require(["@/view/product/ld_RS100i"], resolve)
        },
        {
          path: "/product_T100",
          name: "product_T100",
          component: resolve => require(["@/view/product/ld_T100"], resolve)
        },
        {
          path: "/product_CN100C",
          name: "product_CN100C",
          component: resolve => require(["@/view/product/ld_CN100C"], resolve)
        },
        {
          path: "/product_CN1350w",
          name: "product_CN1350w",
          component: resolve => require(["@/view/product/ld_CN1350w"], resolve)
        },
        {
          path: "/product_dmz",
          name: "product_dmz",
          component: resolve => require(["@/view/product/dmz"], resolve)
        },
        {
          path: "/product_solution_v_1",
          name: "product_solution_v_1",
          component: resolve => require(["@/view/solution/v_1"], resolve)
        },
        {
          path: "/product_solution_v_2",
          name: "product_solution_v_2",
          component: resolve => require(["@/view/solution/v_12"], resolve)
        },
        {
          path: "/AerialService",
          name: "AerialService",
          component: resolve => require(["@/view/service/Aerial"], resolve)
        },
        {
          path: "/modelService",
          name: "modelService",
          component: resolve => require(["@/view/service/model"], resolve)
        },
        {
          path: "/3DScanService",
          name: "3DScanService",
          component: resolve => require(["@/view/service/scan"], resolve)
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/service/service"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        {
          path: "/solution",
          name: "solution",
          component: resolve => require(["@/view/solution/solution"], resolve),
          meta: {
            title: "解决方案"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/solution_v_2",
          name: "solution_v_2",
          component: resolve => require(["@/view/solution/v_2"], resolve)
        },
        {
          path: "/solution_v_3",
          name: "solution_v_3",
          component: resolve => require(["@/view/solution/v_3"], resolve)
        },
        {
          path: "/solution_v_4",
          name: "solution_v_4",
          component: resolve => require(["@/view/solution/v_4"], resolve)
        },
        {
          path: "/solution_v_5",
          name: "solution_v_5",
          component: resolve => require(["@/view/solution/v_5"], resolve)
        },
        {
          path: "/solution_v_6",
          name: "solution_v_6",
          component: resolve => require(["@/view/solution/v_6"], resolve)
        },
        {
          path: "/solution_v_7",
          name: "solution_v_7",
          component: resolve => require(["@/view/solution/v_7"], resolve)
        },
        {
          path: "/solution_v_8",
          name: "solution_v_8",
          component: resolve => require(["@/view/solution/v_8"], resolve)
        },
        {
          path: "/solution_v_9",
          name: "solution_v_9",
          component: resolve => require(["@/view/solution/v_9"], resolve)
        },
        {
          path: "/solution_v_10",
          name: "solution_v_10",
          component: resolve => require(["@/view/solution/v_10"], resolve)
        },
        {
          path: "/solution_v_11",
          name: "solution_v_11",
          component: resolve => require(["@/view/solution/v_11"], resolve)
        },
        {
          path: "/solution_v_12",
          name: "solution_v_12",
          component: resolve => require(["@/view/solution/v_13"], resolve)
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js